import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-menu-dashboard',
  templateUrl: './no-menu-dashboard.component.html',
  styleUrls: ['./no-menu-dashboard.component.css']
})
export class NoMenuDashboardComponent implements OnInit {

  constructor() { 
    document.body.style.backgroundColor = "#fff"
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/no-menu-dashboard/no-menu-dashboard.component.ts